import {createContext, FC, ReactNode, useState} from "react";

interface GlobalVariablesProviderProps {
    children: ReactNode;
}

export const GlobalVariablesContext = createContext<any>(null)

export const GlobalVariablesProvider:FC<GlobalVariablesProviderProps> = ({children}) => {

    const [headerTitle, setHeaderTitle] = useState('')

    return (
        <GlobalVariablesContext.Provider value={{headerTitle, setHeaderTitle}}>
            {children}
        </GlobalVariablesContext.Provider>
    )
}